type TimeRange = '7d' | '30d' | '90d' | 'all';
type Granularity = 'day' | 'week' | 'month';

interface MetricsData {
  sent: number;
  opened: number;
  clicked: number;
  replied: number;
  openRate: number;
  clickRate: number;
  replyRate: number;
}

interface TimelineDataPoint {
  date: string;
  sent: number;
  opened: number;
  clicked: number;
  replied: number;
}

interface CampaignMetric {
  id: string;
  name: string;
  status: string;
  sent: number;
  opened: number;
  openRate: number;
  clicked: number;
  clickRate: number;
  replied: number;
  replyRate: number;
  createdAt: Date;
}

class ReportsService {
  private baseUrl = '/api/reports';

  async getOverview(timeRange: TimeRange): Promise<MetricsData> {
    const response = await fetch(
      `${this.baseUrl}/overview?timeRange=${timeRange}`,
      { credentials: 'include' }
    );

    if (!response.ok) {
      throw new Error('Failed to fetch overview metrics');
    }

    return response.json();
  }

  async getTimeline(
    timeRange: TimeRange,
    granularity: Granularity = 'day'
  ): Promise<TimelineDataPoint[]> {
    const response = await fetch(
      `${this.baseUrl}/timeline?timeRange=${timeRange}&granularity=${granularity}`,
      { credentials: 'include' }
    );

    if (!response.ok) {
      throw new Error('Failed to fetch timeline data');
    }

    return response.json();
  }

  async getCampaigns(timeRange: TimeRange): Promise<CampaignMetric[]> {
    const response = await fetch(
      `${this.baseUrl}/campaigns?timeRange=${timeRange}`,
      { credentials: 'include' }
    );

    if (!response.ok) {
      throw new Error('Failed to fetch campaign metrics');
    }

    return response.json();
  }

  async exportCsv(timeRange: TimeRange): Promise<Blob> {
    const response = await fetch(
      `${this.baseUrl}/export?timeRange=${timeRange}`,
      { credentials: 'include' }
    );

    if (!response.ok) {
      throw new Error('Failed to export reports');
    }

    return response.blob();
  }
}

export const reportsService = new ReportsService();
export type { MetricsData, TimelineDataPoint, CampaignMetric, TimeRange, Granularity };
